export const types = [
    {
        name: 'Model',
        manufacturer: ['Alcon', 'B+L', 'Rayner', 'J&J', 'Physiol']
    },
    //Alcon Models
    {
        name: 'T2',
        manufacturer: ['Alcon']
    },
    {
        name: 'T3',
        manufacturer: ['Alcon']
    },
    {
        name: 'T4',
        manufacturer: ['Alcon']
    },
    {
        name: 'T5',
        manufacturer: ['Alcon']
    },
    {
        name: 'T6',
        manufacturer: ['Alcon']
    },
    {
        name: 'T7',
        manufacturer: ['Alcon']
    },
    {
        name: 'T8',
        manufacturer: ['Alcon']
    },
    {
        name: 'T9',
        manufacturer: ['Alcon']
    },
    //B+L Models
    {
        name: '1.25',
        manufacturer: ['B+L']
    },
    {
        name: '2',
        manufacturer: ['B+L']
    },
    {
        name: '2.75',
        manufacturer: ['B+L']
    },
    {
        name: '3.5',
        manufacturer: ['B+L']
    },
    {
        name: '4.25',
        manufacturer: ['B+L']
    },
    {
        name: '5',
        manufacturer: ['B+L']
    },
    {
        name: '5.75',
        manufacturer: ['B+L']
    },
    //J&J, Physiol and Rayner models
    {
        name: '100',
        manufacturer: ['Rayner']
    },
    {
        name: '150',
        manufacturer: ['Rayner', 'J&J', 'Physiol']
    },
    {
        name: '200',
        manufacturer: ['Rayner']
    },
    {
        name: '225',
        manufacturer: ['J&J', 'Physiol']
    },
    {
        name: '250',
        manufacturer: ['Rayner']
    },
    {
        name: '300',
        manufacturer: ['Rayner', 'J&J', 'Physiol']
    },
    {
        name: '350',
        manufacturer: ['Rayner']
    },
    {
        name: '375',
        manufacturer: ['J&J', 'Physiol']
    },
    {
        name: '400',
        manufacturer: ['Rayner']
    },
    {
        name: '450',
        manufacturer: ['Rayner', 'J&J', 'Physiol']
    },
    {
        name: '500',
        manufacturer: ['Rayner']
    },
    {
        name: '525',
        manufacturer: ['J&J', 'Physiol']
    },
    {
        name: '550',
        manufacturer: ['Rayner']
    },
    {
        name: '600',
        manufacturer: ['Rayner', 'J&J', 'Physiol']
    },
];
